import { checkForCloudflare, cloudflareId } from '../Shared/userCentrics';

declare var __ucCmp: any;

function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

function setValidationText(element: JQuery<HTMLElement>, text: string) {
    $(element).removeClass('field-validation-valid').addClass('field-validation-error').text(text);
}

function clearValidationText(element: JQuery<HTMLElement>) {
    $(element).removeClass('field-validation-error').addClass('field-validation-valid').text('');
}

$('.upload-field').on('change', function () {
    const fileField = this as HTMLInputElement;
    var uploadedFiles = fileField.files;
    var errorContainer = $('#kontaktError');
    errorContainer.text('');
    for (let i = 0; i < uploadedFiles.length; i++) {
        const size = uploadedFiles[i].size / 1024;
        if (size > 2000) {
            errorContainer.text('Die Datei darf nicht größer als 2 MB sein.');
            $(this).val(null);
            return false;
        }
    }
});

$(document).on('click', 'input.btn.btn-primary', function (e) {
    // This validation targets the multi-form layout (with #formSelect dropdown).
    // Skip it on the single-form FormPicker block page, which has no #firstname/#lastname/#email fields.
    if (!$('#formSelect').length) {
        return;
    }

    const firstName = $('#firstname').val();
    const lastName = $('#lastname').val();
    const email = $('#email').val() as string;

    if (firstName == '') {
        e.preventDefault();
        setValidationText($('#firstname-validation'), 'Bitte geben Sie Ihren Vornamen ein.');
    }
    if (lastName == '') {
        e.preventDefault();
        setValidationText($('#lastname-validation'), 'Bitte geben Sie Ihren Nachnamen ein.');
    }
    if (email == '') {
        e.preventDefault();
        setValidationText($('#email-validation'), 'Bitte geben Sie Ihre E-Mail-Adresse ein.');
    } else if (isValidEmail(email) === false) {
        e.preventDefault();
        setValidationText($('#email-validation'), 'Bitte geben Sie eine gültige E-Mail-Adresse ein.');
    }

    if (email == '' || firstName == '' || lastName == '') {
        e.preventDefault();
        console.log('empty field');
    } else if (isValidEmail(email) == false) {
        e.preventDefault();
        console.log('invalid email');
    }
});

$('#firstname').on('input', function () {
    const firstName = this as HTMLInputElement;
    $('.Vorname').val(firstName.value);

    if (firstName.value != '') {
        clearValidationText($('#firstname-validation'));
    }
});

$('#lastname').on('input', function () {
    const lastname = this as HTMLInputElement;
    $('.Nachname').val(lastname.value);

    if (lastname.value != '') {
        clearValidationText($('#lastname-validation'));
    }
});

$('#email').on('input', function () {
    const email = this as HTMLInputElement;
    $('.Email').val(email.value);

    if (email.value != '') {
        clearValidationText($('#email-validation'));
    }
});

$(document).ready(function () {
    $('div.itemMenu').hide(0);
    $('.menuLine').click(function () {
        var iconChild = $(this).children('div.itemCtrl').children('i.fa');
        var iconImgNormal = $(this).children('div.itemImg').children('span.normal');
        var iconImgEffect = $(this).children('div.itemImg').children('span.effect');
        $(this).next('div.itemMenu').slideToggle(150);
        if ($(iconChild).hasClass('fa-angle-down')) {
            $(iconImgNormal).css('display', 'none');
            $(iconImgEffect).css('display', 'block');
            $(iconChild).removeClass('fa-angle-down').addClass('fa-angle-up');
        } else {
            $(iconImgNormal).css('display', 'block');
            $(iconImgEffect).css('display', 'none');
            $(iconChild).removeClass('fa-angle-up').addClass('fa-angle-down');
        }
    });
    //***************************Umbraco Forms Kontaktformulare***************************//
    if ($('#formSelect').length) {
        var lastselection = window.sessionStorage.getItem('lastselection');
        if (lastselection) {
            $('#formSelect').val(lastselection).change();
        } else if (getParameterByNameInternal('openform')) {
            $('#formSelect').val(getParameterByNameInternal('openform')).change();
        }

        //Speichert das Default-Value des Selects und zeigt die Default-Form an
        var startValue = $('#formSelect option:selected').val() as string;
        $('#formSelect').data('pre', startValue);

        checkCloudflare(startValue);

        $('#' + startValue).show();

        $('#formSelect').on('change', function () {
            const selectedValue = $('#formSelect option:selected').val() as string;
            //Value vor dem �ndern um alte Form auszublenden
            var before_change = $(this).data('pre');
            $('#' + before_change).hide();
            $('#' + selectedValue).show();
            window.sessionStorage.setItem('lastselection', selectedValue);

            checkCloudflare(selectedValue);

            $(this).data('pre', $(this).val());
        });
    } else {
        // Single-form page (e.g. FormPicker block): no dropdown, init turnstile for the only form on the page.
        checkCloudflareSingleForm();
    }

    $('form').on('submit', function (e) {
        $(e.target).find('input[type=submit]').prop('disabled', true);
    });
});

function getParameterByNameInternal(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

window['onloadTurnstileCallback'] = onloadTurnstileCallback;

function onloadTurnstileCallback() {
    // Poll for __ucCmp like initUserCentrics does. Without this, if turnstile's script
    // finishes loading before UserCentrics is ready, the callback silently no-ops and
    // the widget never renders.
    if (window['__ucCmp'] !== undefined) {
        __ucCmp.isInitialized().then(() => {
            initCloudflare();
        });
    } else {
        setTimeout(onloadTurnstileCallback, 100);
    }
}

function loadCloudflareScript() {
    var script = document.createElement('script');
    script.onload = () => {
        onloadTurnstileCallback();
    };
    script.defer = true;
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    document.head.appendChild(script);
}

function initCloudflare() {
    if (window['turnstile'] != undefined) {
        __ucCmp.getConsentDetails().then((details) => {
            const cloudflareAllowed = details.services[cloudflareId].consent.given;

            const $formSelect = $('#formSelect');
            const selector = $formSelect.length
                ? '.cf-turnstile-lazy.' + ($formSelect.find('option:selected').val() as string)
                : '.cf-turnstile-lazy';

            checkForCloudflare(cloudflareAllowed, true, selector);
        });
    } else {
        setTimeout(initCloudflare, 100);
    }
}

function checkCloudflareSingleForm() {
    var cloudflareInstances = document.querySelectorAll<HTMLDivElement>('.cf-turnstile-lazy');

    if (cloudflareInstances == null || cloudflareInstances.length < 1) {
        return;
    }

    window.sessionStorage.setItem('cloudflareFormId', '.cf-turnstile-lazy');

    if (window['turnstile'] == undefined) {
        loadCloudflareScript();
    } else {
        initCloudflare();
    }
}

function checkCloudflare(formId: string) {
    var cloudflareInstances = document.querySelectorAll<HTMLDivElement>(
        '.cf-turnstile-lazy.' + formId + ', cf-turnstile-uc.' + formId
    );

    if (cloudflareInstances == null || cloudflareInstances == undefined || cloudflareInstances.length < 1) {
        return;
    }

    window.sessionStorage.setItem('cloudflareFormId', '.cf-turnstile-lazy.' + formId);

    if (window['turnstile'] == undefined) {
        loadCloudflareScript();
    } else {
        initCloudflare();
    }
}
